import React from 'react';
import './SubscriptionTiers.css';

interface Tier {
    id: string;
    name: string;
    price: string;
    features: string[];
}

interface SubscriptionTiersProps {
    onSelectTier: (tier: Tier) => void;
    selectedTier: string | null;
}

const SubscriptionTiers: React.FC<SubscriptionTiersProps> = ({ onSelectTier, selectedTier }) => {
    const tiers: Tier[] = [
        { id: 'mortal', name: 'Mortal', price: '$9.99/month', features: ['Access to all 12 labors', 'Basic progress tracking'] },
        { id: 'hero', name: 'Hero', price: '$19.99/month', features: ['Access to all 12 labors', 'Advanced progress tracking', 'Exclusive mythological content'] },
        { id: 'olympian', name: 'Olympian', price: '$29.99/month', features: ['Access for up to 4 accounts', 'All Hero features', 'Family leaderboard'] },
    ];

    return (
        <div className="space-y-8">
            <h2 className="text-4xl font-bold text-center text-terracotta font-cinzel">Choose Your Destiny</h2>
            <div className="grid gap-6 md:grid-cols-3">
                {tiers.map((tier) => (
                    <div
                        key={tier.id}
                        className={`greek-stone-tablet ${selectedTier === tier.id ? 'selected' : ''}`}
                        onClick={() => onSelectTier(tier)}
                    >
                        <h3 className="text-3xl font-bold mb-4 relative z-10 text-stone-dark font-cinzel">{tier.name}</h3>
                        <p className="text-2xl font-bold mb-4 relative z-10 text-terracotta font-cinzel">{tier.price}</p>
                        <ul className="list-none p-0 relative z-10">
                            {tier.features.map((feature, index) => (
                                <li key={index} className="mb-2 text-left text-stone-dark flex items-center">
                                    <svg className="w-5 h-5 mr-2 text-yellow-300" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                    <span className="text-m font-bold font-cinzel">{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubscriptionTiers;